import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableVerticalFinancial from './TableVerticalFinancial';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerFinancialByField = () => {

  debugLogPages(':: ComparisonContainerFinancialByField');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { financialsS } = useSelector((state) => state.financial);
  const { listFieldsFinancial } = useSelector((state) => state.moduleConfig);
  const { comparisonFinancialComboEnabled } = useSelector((state) => state.configuration);
  const [listFieldsToCompare, setListFieldsToCompare] = useState();
  const [selectedField, setSelectedField] = useState()

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsFinancial.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  const handleChangeSelectCompare = (event) => {

    if (event != null) {
      setSelectedField(event);

      let selectedIds = "";
      let countIds = 0;
      for (let index = 0; index < financialsS.length; index++) {
        if (financialsS[index].isSelected) {
          financialsS[index].isCompared = true;

          if (countIds === 0) {
              selectedIds = selectedIds.concat(financialsS[index].id);
            } else {
              selectedIds = selectedIds.concat(";", financialsS[index].id);
            }

            countIds++;

        }else{
          financialsS[index].isCompared = false;
        }
      }

      const objectCompare = {
        deleted:false,
        compare_ids:selectedIds,
        total_selected:countIds,
        selected_field:event.field,
        is_compare_all_fields:false
      }
      dispatch(startRegisterCompareResult(objectCompare));


    } else {
      setSelectedField(null);
    }
  };


  return (
    <div>

      <div className="flexbox-title">
         <h2>{t("general.compare-financial")}</h2>
      </div>

      <br />

      {
        comparisonFinancialComboEnabled === "true" &&
        <div>
          <Select
            myFontSize="14px"
            onChange={(event) => handleChangeSelectCompare(event)}
            className={`basic-single form-control`}
            classNamePrefix="select"
            name="texto"
            options={listFieldsToCompare}
            getOptionLabel={(option) => t(`${option.module_text}.synthetic.${option.field}`)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder="Seleccione un Campo para comparar"
          />

          {selectedField && selectedField.field &&
            (<TableVerticalFinancial selectedField={selectedField} data={financialsS} />)
          }

        </div>
      }

      <br />

    </div>
  )
}

export default ComparisonContainerFinancialByField